import React from 'react'
import './About.css'
import smileyFood from '../images/smiley-food.png'
 
const About = () => {
  return (
    <div className='about'>
        <h2>Welcome to "EAT HEALTHY n STAY FIT!"</h2>
        <p className='giveMargin'>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Totam, atque.</p>
        <h3>“Eating healthy food fills your body with energy and nutrients. Imagine your cells smiling back at you and saying: 'Thank you! '”</h3>
        <h5 className='giveMargin'>A wise lady</h5>
        <h3>"Let food be thy medicine, and let medicine be thy food."</h3>
        <h5 className='giveMargin'>A wise man</h5>
        <img className='smileyFood' src={smileyFood} alt="" />
    </div>

  )
}

export default About